import { useEffect, useState } from "react";
import { api, fmtDateTime } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { RagBadge } from "./Badges";
import { Thumb } from "./PhotoUpload";

const InspectionDetail = ({ id, onClose }) => {
  const [ins, setIns] = useState(null);
  useEffect(() => {
    if (id) api.get(`/inspections/${id}`).then((r) => setIns(r.data));
    else setIns(null);
  }, [id]);
  return (
    <Dialog open={!!id} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto border-slate-700 bg-ink-2 sm:max-w-xl" data-testid="inspection-detail-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl uppercase">{ins?.template_name}</DialogTitle></DialogHeader>
        {ins && (
          <div className="space-y-3 text-sm">
            <p className="text-slate-400">{fmtDateTime(ins.performed_at)} - {ins.performed_by} - {ins.asset_name || ins.location || "Site"}{ins.offline ? " - captured offline" : ""}</p>
            {ins.work_order_ref && <p className="text-amber-300">Defect work order raised: {ins.work_order_ref}</p>}
            {ins.checkins?.length > 0 && (
              <div className="rounded border border-slate-800 p-2 text-xs" data-testid="inspection-checkins">
                <p className="eyebrow mb-1">Area check-ins</p>
                {ins.checkins.map((c) => <p key={c.area_id}>{c.area_name}: {fmtDateTime(c.at)} - {c.method === "qr" ? "QR verified" : c.method === "code" ? "label code" : `manual (${c.reason})`}</p>)}
              </div>
            )}
            {ins.results.map((r, i) => (
              <div key={i} className="flex items-start justify-between gap-2 border-b border-slate-800 py-1.5">
                <span><span className="text-slate-500">{r.section}:</span> {r.item}{r.reading != null && r.reading !== "" && <span className="ml-1 font-mono text-cyan-300">{r.reading}{r.unit}</span>}{r.note && <span className="block text-xs text-amber-200">{r.note}</span>}{r.photos?.length > 0 && <span className="mt-1 flex flex-wrap gap-1">{r.photos.map((p) => <Thumb key={p} src={p} />)}</span>}</span>
                <RagBadge status={r.result === "pass" ? "green" : r.result === "fail" ? "red" : "amber"} label={r.result} />
              </div>
            ))}
            {ins.notes && <p className="text-slate-300">Notes: {ins.notes}</p>}
            <div className="flex flex-wrap gap-2">{ins.photos.map((p) => <Thumb key={p} src={p} />)}</div>
            <p className="eyebrow">Signature</p>
            <img src={ins.signature} alt="signature" className="h-20 rounded bg-white" />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export const InspectionHistory = ({ module }) => {
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState(null);
  useEffect(() => {
    api.get("/inspections", { params: { module } }).then((r) => setRows(r.data));
  }, [module]);
  return (
    <div className="panel divide-y divide-slate-800" data-testid={`inspection-history-${module}`}>
      {rows.map((r) => (
        <button key={r.id} onClick={() => setSel(r.id)} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left hover:bg-slate-800/40" data-testid={`inspection-row-${r.id}`}>
          <span>
            <span className="text-sm font-semibold text-slate-100">{r.template_name}</span>
            <span className="block text-xs text-slate-400">{fmtDateTime(r.performed_at)} - {r.performed_by} - {r.asset_name || r.location || "Site"}</span>
          </span>
          <span className="flex items-center gap-2">
            {r.work_order_ref && <span className="hidden font-mono text-xs text-amber-300 sm:inline">{r.work_order_ref}</span>}
            <RagBadge status={r.outcome === "pass" ? "green" : "red"} label={r.outcome === "pass" ? "Pass" : `${r.failed_count} fail`} />
          </span>
        </button>
      ))}
      {!rows.length && <p className="px-4 py-10 text-center text-sm text-slate-500">No inspections recorded yet.</p>}
      <InspectionDetail id={sel} onClose={() => setSel(null)} />
    </div>
  );
};
